import React, { useState, useEffect } from 'react';
import DeclarationFormPage from './DeclarationFormPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { update_ROUsers_master } from '../../../../../features/admin/redux/slice';
import { get_declaration_configs } from '../../../../../features/welcome/redux/slice';
//import FormData from 'form-data';

function DeclarationForm() {
  TabTitle('Gift Register - Entry Delegator Flows');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { roUsers_MasterList, remove_entry_delegatorLoading } = useSelector(
    (state) => state.admin
  );

  const {
    declarationConfigs,
    get_declaration_configsLoading,
    declarationConfigsPagination
  } = useSelector((state) => state.dashboard);

  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [showDisablePopup, setShowDisablePopup] = useState(false);

  //console.log('searchRequest', searchRequest);
  //console.log(triggerFilter);
  console.log('roUsers_MasterList', roUsers_MasterList);

  useEffect(() => {
    handleGetDeclarationConfigs();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetDeclarationConfigs();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest]); //page,

  const handleGetDeclarationConfigs = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest
    };
    dispatch(get_declaration_configs(payload));
  };

  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  };*/
  const handleDeleteRequest = (record) => {
    // let formdata = new FormData();
    // console.log('record@@@@@@', record?.record);
    // formdata.append('deactivate', true);
    // formdata.append('id', record?.record?.id);
    const payload = {
      id: record?.record?.id,
      deactivate: true
    };

    dispatch(update_ROUsers_master(payload));
  };
  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <DeclarationFormPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          setSearchRequest={setSearchRequest}
          showDisablePopup={showDisablePopup}
          setShowDisablePopup={setShowDisablePopup}
          handleDeleteRequest={handleDeleteRequest}
          remove_entry_delegatorLoading={remove_entry_delegatorLoading}
          adminBulkGiftConfigs={declarationConfigs}
          adminBulkGiftConfigsLoading={get_declaration_configsLoading}
          pagination={declarationConfigsPagination}
        />
      </div>
    </CustomLayout>
  );
}
export default DeclarationForm;
